import Vue from 'vue';
import Vuex from 'vuex';
import Bus from '@/libs/bus';
import Config from '@/config';
import {getToken, setToken} from '@/libs/util';
import {passwordLogin, smsLogin, resetPassword, wxOAuthLogin} from '@/api';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        charging: false,
        token: getToken(),
        // 地图中心坐标
        centerPoint: {
            latitude: 29.61057,
            longitude: 106.53808
        },
        // websocket
        socket: {
            message: {},
            socketMsgQueue: [],
            isConnected: false,
            reconnectError: false,
            heartBeatTimer: 0,
            heartBeatInterval: 2000,
        }
    },
    getters: {
        token: (state) => state.token,
        user: (state) => state.user,
        charging: (state) => state.charging,
        centerPoint: (state) => state.centerPoint,
        message: (state) => state.socket.message
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            setToken(token);
        },
        setUser(state, user) {
            state.user = user;
        },
        setCharging(state, charging) {
            state.charging = charging;
        },
        setCenterPoint(state, centerPoint) {
            state.centerPoint = centerPoint;
        },
        ////////// websocket start //////////
        SOCKET_ONOPEN(state, event) {
            state.socket.isConnected = true;
            // 发送队列中暂存的数据
            for (let i = 0; i < state.socket.socketMsgQueue.length; i++) {
                Vue.prototype.$socket.sendObj(state.socket.socketMsgQueue[i]);
            }
            this.socketMsgQueue = [];
            // 心跳
            state.socket.heartBeatTimer = setInterval(() => {
                state.socket.isConnected && Vue.prototype.$socket.sendObj({
                    service: 'system',
                    method: 'heartBeat',
                    param: '心跳'
                });
            }, state.socket.heartBeatInterval);
        },
        SOCKET_ONCLOSE(state, event) {
            state.socket.isConnected = false;

            clearInterval(state.socket.heartBeatTimer);
            state.socket.heartBeatTimer = 0;

            if (event.code === 1002 || event.code === 1005) {
                Vue.prototype.$disconnect();
            }
        },
        SOCKET_ONERROR(state, event) {
            console.error(state, event);
        },
        SOCKET_ONMESSAGE(state, message) {
            state.socket.message = message;
            console.log('message', message);
            // push到消息总线
            Bus.$emit(message.command, message.data);
        },
        SOCKET_RECONNECT(state, count) {
            console.info(state, count);
        },
        SOCKET_RECONNECT_ERROR(state) {
            state.socket.reconnectError = true;
        }
        ////////// websocket end //////////
    },
    actions: {
        setUser({commit}, user) {
            commit('setUser', user);
        },
        setToken({commit}, token) {
            commit('setToken', token);
        },
        setCharging({commit}, charging) {
            commit('setCharging', charging);
        },
        setCenterPoint({commit}, centerPoint) {
            commit('setCenterPoint', centerPoint);
        },
        sendMessage({state}, message) {
            if (state.socket.connected) {
                Vue.prototype.$socket.sendObj(message);
            } else {
                state.socket.socketMsgQueue.push(message);
            }
        },
        handlePasswordLogin({commit}, {mobile, password}) {
            return new Promise((resolve, reject) => {
                passwordLogin(mobile.trim(), password).then(res => {
                    if (res.data.code === Config.successCode) {
                        const data = res.data.body;
                        commit('setToken', data.token);
                        commit('setUser', data);
                        resolve(res);
                    } else {
                        reject(new Error(res.data.body.message));
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        handleSmsLogin({commit}, {mobile, code}) {
            return new Promise((resolve, reject) => {
                smsLogin(mobile.trim(), code.trim()).then(res => {
                    if (res.data.code === Config.successCode) {
                        const data = res.data.body;
                        commit('setToken', data.token);
                        commit('setUser', data);
                        resolve(res);
                    } else {
                        reject(new Error(res.data.body.message));
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        handleResetPassword({commit}, {mobile, password, code}) {
            return new Promise((resolve, reject) => {
                resetPassword(mobile.trim(), password, code.trim()).then(res => {
                    if (res.data.code === Config.successCode) {
                        const data = res.data.body;
                        commit('setToken', data.token);
                        commit('setUser', data);
                        resolve(res);
                    } else {
                        reject(new Error(res.data.body.message));
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        handleWxOAuthLogin({commit}, code) {
            return new Promise((resolve, reject) => {
                wxOAuthLogin(code).then(res => {
                    if (res.data.code === Config.successCode && res.data.body) {
                        const data = res.data.body;
                        commit('setToken', data.token);
                        commit('setUser', data);
                        resolve(res);
                    } else {
                        reject(new Error(res.data.body.message));
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        }
    },
    modules: {}
});
